import { render, staticRenderFns } from "./CollectionActPerformanceForGroup.vue?vue&type=template&id=e75f5ac8&scoped=true&"
import script from "./CollectionActPerformanceForGroup.vue?vue&type=script&lang=js&"
export * from "./CollectionActPerformanceForGroup.vue?vue&type=script&lang=js&"
import style0 from "./CollectionActPerformanceForGroup.vue?vue&type=style&index=0&id=e75f5ac8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e75f5ac8",
  null
  
)

export default component.exports